export enum RightClickMenu {
  OPEN_IN_NEW_TAB = 'OPEN_IN_NEW_TAB'
}
